import React, { useState, useCallback } from 'react';
import { BASEURL, FILEURL } from '../Config';
import axios from 'axios';
import swal from 'sweetalert';
import { useDropzone } from 'react-dropzone';

const MyDropzone = (props) => {
  const { file, setFile, setError, fromPage } = props;
  const [fileKey, setFileKey] = useState("");
  const [thbErr, setThbErr] = useState(false);
  const [thbSucess, setThbSuccess] = useState(false);
  const [uploading, setUploading] = useState(false);
  const [deleting, setDeleting] = useState(false);

  const saveFileAPI = (file) => {
    setUploading(true)
    console.log('Saving file:', file);
    let form_data = new FormData();
    form_data.append('path', 'test');
    form_data.append('file', file);
    axios
      .post(`${BASEURL}/api/v1/fileUpload/file/new`, form_data)
      .then((res) => {
        setUploading(false)
        if (res.status === 200) {
          console.log('res.data', res.data);
          setFile(res.data.key ? res.data.key : res.data.Key);
          setError(false)
          setFileKey(res.data.key ? res.data.key : res.data.Key);
          setThbSuccess(true)
          setThbErr(false)
        } else {
          console.log('res', res);
        }
      })
      .catch((err) => {
        setUploading(false)
        console.log(err.response.data);
      });
  };

  const handleDropzoneFileRemoved = () => {
    console.log('Deleting file');
    setDeleting(true)
    // Call your API here to delete the file
    axios
      .post(`${BASEURL}/api/v1/fileUpload/file/delete`, { filePath: fileKey || file })
      .then((res) => {
        setDeleting(false)
        if (res.status === 200) {
          console.log('res.data', res.data);
          setFile('');
          setThbSuccess(false)
          setThbErr(false)
        } else {
          console.log('res', res);
        }
      })
      .catch((err) => {
        console.log(err.response.data);
        swal('Error in Deleting the Thumbnail', err.response.data, 'error');
        setDeleting(false)
      });
  };
  

  const onDrop = useCallback(
    (acceptedFiles) => {
      if (!file) {
        const file = acceptedFiles[0];
        saveFileAPI(file);
      } else {
        console.log('File already uploaded. Delete the uploaded file to upload a new one.');
        setThbErr(true)
        setThbSuccess(false)
      }
    },
    [file, saveFileAPI]
  );

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    multiple: false,
    accept: 'image/*',
  });

  return (
    <div className="col-md-12 col-sm-12">
      <div className="mb-3 mt-3 mt-xl-0">
        <div {...getRootProps({ className: 'dropzone needsclick' })}>
          <input {...getInputProps()} />
          <div className={`dz-message ${isDragActive ? 'active' : ''}`}>
            <i className="h3 text-muted dripicons-cloud-upload" />
            <h4>Drop files here or click to upload.</h4>
          </div>
        </div>
        <div className="dropzone-previews mt-3">
          {file && (
            <div className="card mt-1 mb-0 shadow-none border">
              <div className="p-2">
                <div className="row align-items-center">
                  <div className="col-auto">
                    <img src={FILEURL+'/'+file} className="avatar-sm rounded bg-light" alt="" />
                  </div>
                  {fromPage === "editBookPage" && (
                    <div className="col ps-0">
                      <a href="javascript:void(0);" className="text-muted fw-bold" data-dz-name>
                        {file}
                      </a>
                    </div>
                  )}
                  <div className="col-auto">
                    <button className="btn btn-link btn-lg text-muted" onClick={handleDropzoneFileRemoved}>
                      <i className="dripicons-cross" />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      {thbErr && <p className="text-danger">A file has already been uploaded. Delete the uploaded file to upload a new one.</p>}
      {thbSucess && <p className='text-success'>Successfully uploaded the file</p>}
      {uploading && <p className='text-primary'>Uploading the file ......</p>}
      {deleting && <p className='text-primary'>Deleting the file ......</p>}
    </div>
  );
};

export default MyDropzone;
